import React, { useRef } from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { Link } from "gatsby";
import { INLINES } from "@contentful/rich-text-types";
import { wordFixerForGTM } from "../../../shared/utils/stringUtilities"

// Styles //
import "./paragraphCard.scss";

interface ParagraphCardProps {
    title: string;
    description?: { json: any };
    imageSrc: string;
    link?: string | null;
    index: number;
}

const ParagraphCard = (props: ParagraphCardProps) => {
    const { title, description, imageSrc, index, link } = props;
    const ref = useRef<HTMLSpanElement>(null);

    const toggleClass = () => {
        ref.current?.classList.toggle("rotated");
        ref.current?.nextElementSibling?.classList.toggle("open");
    };

    //Bloque creado para google tag manager//	
	const gtmBasedOnTitle = (title) =>{
		return title !== 'Formalización del empleo' ?
               `gtm_aqui_${wordFixerForGTM(title)}_solicitud_empresas`
               : ''
	}
	//Bloque creado para google tag manager//
    
    // Funcion para renderizar contenido de texto de tipo json provenientes de contentful
    const contentfulRenderOptions = {
        renderNode: {
            [INLINES.HYPERLINK]: ({ data }, children) => (
                <a
                    className={gtmBasedOnTitle(title)}
                    style={{ color: "var(--color-magenta-white)" }}
                    href={data.uri}
                    target={"_blank"}
                    rel={"noopener noreferrer"}
                >
                    {children}
                </a>
            ),
        },
        renderText: (text) =>
        text.split("\n").flatMap((txt, i) => [i > 0 && <br />, txt]),
    }

    return (
        <>
            {link ? (
                <div
                    className={`m-paragraph-card gtmEmpresasHoverButton-${title
                        .normalize("NFD")
                        .replace(/[\u0300-\u036f :,.]/g, "")}`}
                    id={title}
                >
                    <Link
                        to={link}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <figure className={`gtmEmpresasClickButton-${title
                            .normalize("NFD")
                            .replace(/[\u0300-\u036f :,.]/g, "")}`}>
                            <img src={imageSrc} alt={title} />
                            <figcaption>{title}</figcaption>
                        </figure>
                    </Link>
                    <span className={`m-paragraph-card__more`} ref={ref} onClick={toggleClass}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24.168"
                            height="15.55"
                            viewBox="0 0 24.168 15.55"
                        >
                            <path
                                id="Trazado_320"
                                data-name="Trazado 320"
                                d="M3625.546-718.067l10.037,11.226,11.226-11.226"
                                transform="translate(-3624.055 719.481)"
                                fill="none"
                                stroke="#ee2b7b"
                                strokeWidth="4"
                            />
                        </svg>
                    </span>
                    <div
                        className='m-paragraph-card__content'
                    >
                        {description &&
                            documentToReactComponents(description.json, contentfulRenderOptions)}
                    </div>
                </div >
            ) : (
                <div
                    className={`m-paragraph-card gtmEmpresasHoverButton-${title
                        .normalize("NFD")
                        .replace(/[\u0300-\u036f :,.]/g, "")}`}
                    key={index}
                    id={title}
                >
                    <figure className={`gtmEmpresasClickButton-${title
                        .normalize("NFD")
                        .replace(/[\u0300-\u036f :,.]/g, "")}`}>
                        <img src={imageSrc} alt={title} />
                        <figcaption>{title}</figcaption>
                    </figure>
                    <span
                        ref={ref}
                        className={`m-paragraph-card__more`}
                        onClick={toggleClass}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24.168"
                            height="15.55"
                            viewBox="0 0 24.168 15.55"
                        >
                            <path
                                id="Trazado_320"
                                data-name="Trazado 320"
                                d="M3625.546-718.067l10.037,11.226,11.226-11.226"
                                transform="translate(-3624.055 719.481)"
                                fill="none"
                                stroke="#ee2b7b"
                                strokeWidth="4"
                            />
                        </svg>
                    </span>
                    <div className={`m-paragraph-card__content`}>
                        {description &&
                            documentToReactComponents(description.json, contentfulRenderOptions)}
                    </div>
                </div>
            )}
        </>
    );
};

export default ParagraphCard;
